import { defineMessages } from "react-intl"

export const inventoryAndIntakeMessages = defineMessages({
	disabledForInUseVehicle: {
		defaultMessage: "This option is not available for vehicles which were already in use.",
		id: "inventoryAndIntake.inventory.disabledForInUseVehicle",
	},
	minimumUsageTimeNotReached: {
		defaultMessage: "The minimum usage period for this vehicle has not yet been reached.",
		id: "inventoryAndIntake.inventory.minimumUsageTimeNotReached",
	},
})
